// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import type { intlShape } from 'react-intl';
import Error500 from '.';
import { Router } from '../../../router';
import { verticalNameSelector } from '~/common/selectors/config';

type Props = {
  intl: intlShape,
  verticalName: string,
};

type MapStateToProps = {
  verticalName: string,
};

class Component extends React.Component<Props> {
  componentDidMount(): void {
    Router.prefetch('/index');
  }

  render(): React.Node {
    return <Error500 {...this.props} />;
  }
}

const mapStateToProps = (state): MapStateToProps => ({
  verticalName: verticalNameSelector(state),
});

const Error500Container = connect(mapStateToProps)(injectIntl(Component));

Error500Container.displayName = 'Error500Container';

export default Error500Container;



// WEBPACK FOOTER //
// ./app/Error/components/Error500/container.js